import firebase from "firebase";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBqF6Jdpa6UHK503R2dyeouMQeLakwBaoU",
    authDomain: "varianti-c582d.firebaseapp.com",
    projectId: "varianti-c582d",
    storageBucket: "varianti-c582d.appspot.com",
    messagingSenderId: "1033012338724",
    appId: "1:1033012338724:web:66a0102a1ed65d514bf8b1",
    measurementId: "G-54F1YBRFYV"
};

// Test server
// const firebaseConfig = {
//     apiKey: "AIzaSyCiMa4YMiOrW19Kg4vo0N9mQX50JMHbpoA",
//     authDomain: "variant-272e0.firebaseapp.com",
//     projectId: "variant-272e0",
//     storageBucket: "variant-272e0.appspot.com",
//     messagingSenderId: "384381808995",
//     appId: "1:384381808995:web:b10fd64a86eb5418986356",
//     measurementId: "G-8J3BWSV9T8"
// };
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();
const auth = firebase.auth();

export { auth };
export default db;